// extracted by mini-css-extract-plugin
module.exports = {"blog-categories-sidebar-wrapper-hide-mobile":"PlatformCategoriesSidebar_blog-categories-sidebar-wrapper-hide-mobile__eJEWj"};